import { useURLParameters } from '#app/hooks/useURLParameters.js';

export type EmbedStructureVariant = 'horizontal' | 'vertical';

type EmbedVariant = {
  structure: EmbedStructureVariant;
};

const isValidEmbedStructure = (
  structure?: string,
): structure is EmbedStructureVariant => {
  return structure === 'horizontal' || structure === 'vertical';
};

export const useEmbedVariant = (): EmbedVariant => {
  const [urlParameters] = useURLParameters('/s/@slug/embed');
  return {
    structure: isValidEmbedStructure(urlParameters.structure)
      ? urlParameters.structure
      : 'horizontal',
  };
};
